export default {
  applyChangesButton: 'Použiť zmeny',
  buttonJumpToStart: 'Prejsť na začiatok',
  buttonRewind: 'Posunúť o {0} krokov ({1}) dozadu',
  buttonPlay: 'Spustiť',
  buttonPause: 'Pozastaviť',
  buttonFastForward: 'Posunúť o {0} krokov ({1}) dopredu',
  buttonJumpToEnd: 'Prejsť na koniec',
  buttonNextStep: 'Ďalší krok receptu',
  buttonPrevStep: 'Predchádzajúci krok receptu',
};
